import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RedirectRoutes } from './core/enums/routes';
import { AuthGuard } from './core/auth-guard/auth.guard';
import { ChooseOrgComponent } from './components/choose-org/choose-org.component';
import { Error500Component } from './modules/errors/error500/error500.component';
import { Error404Component } from './modules/errors/error404/error404.component';

// All authenticated component imports removed - now lazy-loaded via LayoutModule
// This includes: ProfileComponent, SupportComponent, TeamComponent, AppsComponent,
// DashboardComponent, BuilderComponent, NotificationsComponent, etc.

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth/login',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'login',
    redirectTo: 'auth/login',
    pathMatch: 'full',
  },
  {
    path: 'error',
    loadChildren: () =>
      import('./modules/errors/errors.module').then((m) => m.ErrorsModule),
  },
  {
    path: RedirectRoutes.CHOOSEORG,
    component: ChooseOrgComponent,
    canActivate: [AuthGuard],
  },
  // Public embed routes - LAZY-LOADED via IntegratorModule
  {
    path: 'room/share',
    loadChildren: () =>
      import('./components/integrator.module').then((m) => m.ShareRoomRoutingModule),
  },
  {
    path: 'ai-tutor/share',
    loadChildren: () =>
      import('./components/integrator.module').then((m) => m.ShareTutorRoutingModule),
  },
  {
    path: 'room/web-integrator',
    loadChildren: () =>
      import('./components/integrator.module').then((m) => m.WebIntegratorRoutingModule),
  },
  {
    path: 'ai-tutor/web-integrator',
    loadChildren: () =>
      import('./components/integrator.module').then((m) => m.TutorWebIntegratorRoutingModule),
  },
  // LAZY-LOADED LayoutModule - contains all authenticated routes
  // This moves SharedModule (Quill, Stripe, TagifyModule, etc.) to lazy chunk
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./_metronic/layout/layout.module').then((m) => m.LayoutModule),
  },
  {
    path: RedirectRoutes.UNAUTHORIZED,
    component: Error500Component,
    data: {
      title: RedirectRoutes.UNAUTHORIZEDLABEL,
    },
  },
  {
    path: RedirectRoutes.NOTFOUND,
    component: Error404Component,
    data: { title: RedirectRoutes.NOTFOUNDLABEL },
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
